import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Changelog from "./pages/Changelog";

function IframeApp() {
  return (
    <iframe
      src="/app.html"
      title="LIB Gestione Incassi"
      className="app-frame"
      data-testid="gestione-incassi-iframe"
    />
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/changelog" element={<Changelog />} />
        <Route path="*" element={<IframeApp />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
